import { Fragment } from "react";

export const searchColumns = ["driver_mobile", "car_no", "current_car_status"];

export const driverData = [
  {
    id: 161,
    driverId: 27182,
    lat: 10.9975551,
    lng: 76.9871159,
    lastUpdatedOn: "2022-06-01T11:00:00+05:30",
    currentCarStatus: "Blocked",
    lastDutyOn: "2022-02-21T11:28:36+05:30",
    isAvailableForBid: false,
    carNo: "TEST004",
    todayRevenue: 0.0,
    driverName: "Murugan",
    serviceCityId: 1,
    driverMobile: "9043240185",
    carModel: null,
    carId: 1791,
    speedInKmh: "0.1",
    deviceId: "44787636878abb45",
    driverRatingAvg: 0.0,
    carTypeId: 1,
    megacabsRating: 0.0,
    aggregatorId: null,
  },
  {
    id: 368,
    driverId: 6895,
    lat: 28.53531076,
    lng: 77.08937231,
    lastUpdatedOn: "2022-06-01T11:00:12+05:30",
    currentCarStatus: "Blocked",
    lastDutyOn: "2022-04-06T06:34:29+05:30",
    isAvailableForBid: false,
    carNo: "TEST001",
    todayRevenue: 1148.0,
    driverName: "Gopal",
    serviceCityId: 1,
    driverMobile: "9566750543",
    carModel: null,
    carId: 1782,
    speedInKmh: "0",
    deviceId: "7dbf485f9f5ed299",
    driverRatingAvg: 4.99,
    carTypeId: 1,
    megacabsRating: 5.0,
    aggregatorId: null,
  },
  {
    id: 383,
    driverId: 6895,
    lat: 10.9973089,
    lng: 76.9871056,
    lastUpdatedOn: "2022-06-01T11:00:04+05:30",
    currentCarStatus: "Logout",
    lastDutyOn: "2020-05-26T07:50:04+05:30",
    isAvailableForBid: false,
    carNo: "TESTCHD003",
    todayRevenue: 0.0,
    driverName: "",
    serviceCityId: 2,
    driverMobile: "",
    carModel: null,
    carId: 1878,
    speedInKmh: "1.8",
    deviceId: "bf7f65e840e94c4b",
    driverRatingAvg: 4.98,
    carTypeId: 1,
    megacabsRating: 5.0,
    aggregatorId: null,
  },
  {
    id: 3550,
    driverId: 27183,
    lat: 28.5894815,
    lng: 77.0805436,
    lastUpdatedOn: "2023-03-18T11:00:00+05:30",
    currentCarStatus: "Blocked",
    lastDutyOn: "2023-02-14T14:58:09+05:30",
    isAvailableForBid: false,
    carNo: "TESTDEL01",
    todayRevenue: 0.0,
    driverName: "Sumit Ojha",
    serviceCityId: 1,
    driverMobile: "9354068686",
    carModel: null,
    carId: 1797,
    speedInKmh: "0.09412354230880737",
    deviceId: "47a1b3a7c396eecc",
    driverRatingAvg: 0.0,
    carTypeId: 1,
    megacabsRating: 0.0,
    aggregatorId: null,
  },
  {
    id: 3555,
    driverId: 4710,
    lat: 28.5465845,
    lng: 77.2674477,
    lastUpdatedOn: "2023-03-18T11:00:00+05:30",
    currentCarStatus: "Blocked",
    lastDutyOn: "2023-02-09T15:27:04+05:30",
    isAvailableForBid: false,
    carNo: "TEST4331",
    todayRevenue: 0.0,
    driverName: "Nikhil",
    serviceCityId: 1,
    driverMobile: "9560944444",
    carModel: null,
    carId: 119090,
    speedInKmh: "0",
    deviceId: "fd1e4ae8d465695c",
    driverRatingAvg: 4.99,
    carTypeId: 1,
    megacabsRating: 5.0,
    aggregatorId: null,
  },
  {
    id: 4381,
    driverId: 6895,
    lat: 12.94967659,
    lng: 77.58434202,
    lastUpdatedOn: "2022-06-01T11:00:04+05:30",
    currentCarStatus: "Logout",
    lastDutyOn: "2020-05-26T07:50:04+05:30",
    isAvailableForBid: false,
    carNo: "TEST3987",
    todayRevenue: 0.0,
    driverName: "",
    serviceCityId: 4,
    driverMobile: "",
    carModel: null,
    carId: 133945,
    speedInKmh: "0.4",
    deviceId: "fb2b4d3d7ffcdef",
    driverRatingAvg: 4.98,
    carTypeId: 13,
    megacabsRating: 5.0,
    aggregatorId: null,
  },
  {
    id: 5232,
    driverId: 6895,
    lat: 28.5904841,
    lng: 77.14865606,
    lastUpdatedOn: "2022-06-01T11:00:04+05:30",
    currentCarStatus: "Logout",
    lastDutyOn: "2021-08-05T06:42:12+05:30",
    isAvailableForBid: false,
    carNo: "CBE-3987",
    todayRevenue: 0.0,
    driverName: "Gopal",
    serviceCityId: 12,
    driverMobile: "9566750543",
    carModel: null,
    carId: 135153,
    speedInKmh: "1.5",
    deviceId: "18af078bf19c81e4",
    driverRatingAvg: 4.99,
    carTypeId: 0,
    megacabsRating: 5.0,
    aggregatorId: null,
  },
  {
    id: 5427,
    driverId: 27182,
    lat: 10.9976798,
    lng: 76.9874134,
    lastUpdatedOn: "2022-03-18T10:20:30+05:30",
    currentCarStatus: "Logout",
    lastDutyOn: "2022-03-16T13:31:47+05:30",
    isAvailableForBid: false,
    carNo: "TEST0001",
    todayRevenue: 0.0,
    driverName: "Murugan",
    serviceCityId: 12,
    driverMobile: "9043240185",
    carModel: null,
    carId: 135366,
    speedInKmh: "0",
    deviceId: "8033e7231e4ff784",
    driverRatingAvg: 0.0,
    carTypeId: 1,
    megacabsRating: 0.0,
    aggregatorId: null,
  },
  {
    id: 5433,
    driverId: 8118,
    lat: 10.9973765,
    lng: 76.987077,
    lastUpdatedOn: "2022-01-03T06:54:15+05:30",
    currentCarStatus: "Logout",
    lastDutyOn: "2021-12-20T12:22:50+05:30",
    isAvailableForBid: false,
    carNo: "TEST0002",
    todayRevenue: 0.0,
    driverName: "Testing2",
    serviceCityId: 12,
    driverMobile: "9876540002",
    carModel: null,
    carId: 135369,
    speedInKmh: "2.7",
    deviceId: "8033e7231e4ff784",
    driverRatingAvg: 4.99,
    carTypeId: 13,
    megacabsRating: 5.0,
    aggregatorId: null,
  },
  {
    id: 5439,
    driverId: 6895,
    lat: 11.0832651,
    lng: 77.3499744,
    lastUpdatedOn: "2022-06-01T11:00:04+05:30",
    currentCarStatus: "Logout",
    lastDutyOn: "2021-04-04T05:24:41+05:30",
    isAvailableForBid: false,
    carNo: "TEST0004",
    todayRevenue: 0.0,
    driverName: "",
    serviceCityId: 12,
    driverMobile: "",
    carModel: null,
    carId: 135375,
    speedInKmh: "0",
    deviceId: "fb2b4d3d7ffcdef",
    driverRatingAvg: 4.99,
    carTypeId: 1,
    megacabsRating: 5.0,
    aggregatorId: null,
  },
  {
    id: 6533,
    driverId: 6895,
    lat: 13.19856096,
    lng: 77.70707837,
    lastUpdatedOn: "2022-06-01T11:00:04+05:30",
    currentCarStatus: "Logout",
    lastDutyOn: "2022-03-24T09:11:14+05:30",
    isAvailableForBid: false,
    carNo: "TESTDEL02",
    todayRevenue: 0.0,
    driverName: "Gopal",
    serviceCityId: 1,
    driverMobile: "9566750543",
    carModel: null,
    carId: 1869,
    speedInKmh: "2.2",
    deviceId: "44787636878abb45",
    driverRatingAvg: 4.99,
    carTypeId: 1,
    megacabsRating: 5.0,
    aggregatorId: null,
  },
  {
    id: 7370,
    driverId: null,
    lat: null,
    lng: null,
    lastUpdatedOn: null,
    currentCarStatus: null,
    lastDutyOn: null,
    isAvailableForBid: false,
    carNo: "",
    todayRevenue: null,
    driverName: null,
    serviceCityId: 0,
    driverMobile: null,
    carModel: null,
    carId: null,
    speedInKmh: null,
    deviceId: null,
    driverRatingAvg: 0.0,
    carTypeId: 0,
    megacabsRating: 0.0,
    aggregatorId: null,
  },
  {
    id: 8028,
    driverId: 6895,
    lat: 22.52871816,
    lng: 88.36419281,
    lastUpdatedOn: "2022-06-01T11:00:04+05:30",
    currentCarStatus: "Logout",
    lastDutyOn: "2020-05-26T07:50:04+05:30",
    isAvailableForBid: false,
    carNo: "KOLTEST01",
    todayRevenue: 0.0,
    driverName: "",
    serviceCityId: 3,
    driverMobile: "",
    carModel: null,
    carId: 138156,
    speedInKmh: "0",
    deviceId: "381c8bcfc2b3c443",
    driverRatingAvg: 4.98,
    carTypeId: 1,
    megacabsRating: 5.0,
    aggregatorId: null,
  },
  {
    id: 14208,
    driverId: null,
    lat: null,
    lng: null,
    lastUpdatedOn: "2022-10-07T15:31:30+05:30",
    currentCarStatus: "Logout",
    lastDutyOn: null,
    isAvailableForBid: false,
    carNo: "TN33BQ17229",
    todayRevenue: 230.0,
    driverName: "",
    serviceCityId: 12,
    driverMobile: "",
    carModel: "SABARO",
    carId: 145560,
    speedInKmh: "4",
    deviceId: null,
    driverRatingAvg: null,
    carTypeId: 1,
    megacabsRating: null,
    aggregatorId: null,
  },
  {
    id: 14777,
    driverId: 6895,
    lat: 12.95182933,
    lng: 77.58662526,
    lastUpdatedOn: "2022-06-01T11:00:04+05:30",
    currentCarStatus: "Logout",
    lastDutyOn: "2021-12-31T06:58:10+05:30",
    isAvailableForBid: false,
    carNo: "TESTBLR001",
    todayRevenue: 0.0,
    driverName: "Gopal",
    serviceCityId: 4,
    driverMobile: "9566750543",
    carModel: null,
    carId: 1884,
    speedInKmh: "1.6",
    deviceId: "af0b47809769863c",
    driverRatingAvg: 4.99,
    carTypeId: 1,
    megacabsRating: 5.0,
    aggregatorId: null,
  },
  {
    id: 17197,
    driverId: 6895,
    lat: 13.19854187,
    lng: 77.70438896,
    lastUpdatedOn: "2022-06-01T11:00:04+05:30",
    currentCarStatus: "Logout",
    lastDutyOn: "2021-12-31T06:57:07+05:30",
    isAvailableForBid: false,
    carNo: "TESTBLR002",
    todayRevenue: 0.0,
    driverName: "Gopal",
    serviceCityId: 4,
    driverMobile: "9566750543",
    carModel: null,
    carId: 1887,
    speedInKmh: "0.8",
    deviceId: "18af078bf19c81e4",
    driverRatingAvg: 4.99,
    carTypeId: 13,
    megacabsRating: 5.0,
    aggregatorId: null,
  },
  {
    id: 17443,
    driverId: 6895,
    lat: 12.95207458,
    lng: 77.58508547,
    lastUpdatedOn: "2022-06-01T11:00:04+05:30",
    currentCarStatus: "Logout",
    lastDutyOn: "2020-05-26T07:50:04+05:30",
    isAvailableForBid: false,
    carNo: "TESTBLR010",
    todayRevenue: 0.0,
    driverName: "",
    serviceCityId: 4,
    driverMobile: "",
    carModel: null,
    carId: 1911,
    speedInKmh: "2",
    deviceId: "3a35857c0556a133",
    driverRatingAvg: 4.97,
    carTypeId: 1,
    megacabsRating: 5.0,
    aggregatorId: null,
  },
  {
    id: 19341,
    driverId: 27175,
    lat: 13.2000139,
    lng: 77.7106654,
    lastUpdatedOn: "2022-01-05T10:30:57+05:30",
    currentCarStatus: "Logout",
    lastDutyOn: "2022-01-05T10:27:11+05:30",
    isAvailableForBid: false,
    carNo: "KA-50-A-6002",
    todayRevenue: 0.0,
    driverName: "Murali N",
    serviceCityId: 4,
    driverMobile: "7996297599",
    carModel: "",
    carId: 151497,
    speedInKmh: "0",
    deviceId: "0be9825dfae8baee",
    driverRatingAvg: 0.0,
    carTypeId: 1,
    megacabsRating: 0.0,
    aggregatorId: null,
  },
  {
    id: 19389,
    driverId: 7932,
    lat: 12.8406167,
    lng: 77.6515183,
    lastUpdatedOn: "2022-11-08T14:39:15+05:30",
    currentCarStatus: "Assigned",
    lastDutyOn: "2022-11-08T14:39:15+05:30",
    isAvailableForBid: false,
    carNo: "KA-50-A-6291",
    todayRevenue: 4808.24,
    driverName: "Siddeshwara K",
    serviceCityId: 4,
    driverMobile: "9844311449",
    carModel: "",
    carId: 151545,
    speedInKmh: "0",
    deviceId: "2c01ec5499cb0e85",
    driverRatingAvg: 5.0,
    carTypeId: 1,
    megacabsRating: 5.0,
    aggregatorId: null,
  },
  {
    id: 19420,
    driverId: 8289,
    lat: 12.9796718,
    lng: 77.6419025,
    lastUpdatedOn: "2023-02-07T15:49:19+05:30",
    currentCarStatus: "Assigned",
    lastDutyOn: "2023-02-07T15:49:19+05:30",
    isAvailableForBid: false,
    carNo: "KA-50-A-6381",
    todayRevenue: 0.0,
    driverName: "Jagadeesha.A.R",
    serviceCityId: 4,
    driverMobile: "9449112456",
    carModel: "",
    carId: 151576,
    speedInKmh: "0",
    deviceId: "eff28c72588af4d2",
    driverRatingAvg: 0.0,
    carTypeId: 1,
    megacabsRating: 5.0,
    aggregatorId: null,
  },
];

export const InventoryFilterColumns = [
  {
    name: "DRIVER NAME",
    value: "driverName",
    type: "text",
  },
  {
    name: "CAR NO",
    value: "carNo",
    type: "text",
  },
  {
    name: "STATUS",
    value: "status",
    type: "select",
  },
  // {
  //   name: "LATITUDE",
  //   value: "lat",
  //   type: "text",
  // },
  // {
  //   name: "LONGITUDE",
  //   value: "lng",
  //   type: "text",
  // },
  {
    name: "DRIVER MOBILE",
    value: "driverMobile",
    type: "text",
  },
  {
    name: (
      <span>
        <Fragment>
          LAST DUTY ON <i className="fa fa-clock-o mr-2"></i>
        </Fragment>
      </span>
    ),
    value: "lastDutyOn",
    type: "date",
  },
  {
    name: (
      <span>
        <Fragment>
          LAST UPDATED ON <i className="fa fa-clock-o mr-2"></i>
        </Fragment>
      </span>
    ),
    value: "lastUpdatedOn",
    type: "date",
  },
];

export const InventoryColumns = [
  {
    name: "DRIVER NAME",
    selector: (row) => row["driverName"],
    sortable: true,
    center: true,
    // width:"130px",
  },
  {
    name: "CAR NO",
    selector: (row) => row["carNo"],
    sortable: true,
    center: true,
    // width:"130px",
  },
  {
    name: "STATUS",
    selector: (row) => row["currentCarStatus"],
    sortable: true,
    center: true,
    // width:"130px",
  },
  // {
  //   name: "LATITUDE",
  //   selector: (row) => row["lat"],
  //   sortable: true,
  //   center: true,
  //   // width:"130px",
  // },
  // {
  //   name: "LONGITUDE",
  //   selector: (row) => row["lng"],
  //   sortable: true,
  //   center: true,
  //   // width:"130px",
  // },
  {
    name: "DRIVER MOBILE",
    selector: (row) => row["driverMobile"],
    sortable: true,
    center: true,
    // width:"130px",
  },
  {
    name: "LAST DUTY ON",
    selector: (row) => row["lastDutyOn"],
    sortable: true,
    center: true,
    // width:"130px",
  },
  {
    name: "LAST UPDATED ON",
    selector: (row) => row["lastUpdatedOn"],
    sortable: true,
    center: true,
    // width:"130px",
  },
];
